export default "__VITE_ASSET__CsikaQ6H__"